import { render, staticRenderFns } from "./WebIndex.vue?vue&type=template&id=1fea21b7"
import script from "./WebIndex.vue?vue&type=script&lang=js"
export * from "./WebIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports